import VendorContactModel from './VendorContact'
export default function() {
  return {
    code: null,
    short_name: null,
    name_tc: null,
    name_en: null,
    product_range: null,
    vendor_address: null,
    vendor_tel: null,
    vendor_fax: null,
    vendor_web: null,
    remarks: null,
    enabled: '',
    primary_contact: VendorContactModel()
  }
}